"use client";
import React from "react";
import Image from "next/image";
import { Typography } from "@material-tailwind/react";
import {
  AcademicCapIcon,
  CheckBadgeIcon,
  EyeIcon,
  InboxIcon,
} from "@heroicons/react/24/solid";

import Card from "@material-tailwind/react/components/Card";
import { CheckIcon } from "@heroicons/react/24/outline";

const Users = [
  {
    image: "/image/surya.jpeg",
    username: "Surya Bd Karkee ",
    description:
      "(Managing Director)",
  },
  {
    image: "/image/asha.jpeg",
    username: "Aasha Bhattarai ",
    description:
      "(CEO/ Founder)",
  },
  {
    image: "/image/team2.jpeg",
    username: "Monika Bhatta",
    description:
      "(Trainer)",
  },
  {
    image: "/image/sabi.jpeg",
    username: "Sabi Rajbhandari Shrestha  ",
    description:
      "(International Trainer)",
  },
  {
    image: "/image/ourteam3.jpeg",
    username: "Deepika Pokharel",
    description: "(Councellor)",
  },
];

export function OurTeams() {

  
  return (
    <section className="py-18 pt-5">
    <div className="container mx-auto grid grid-cols-1 place-items-center gap-10 lg:grid-cols-3 animate-fade duration-500">
      <div className="col-span-3 lg:py-20">
        <Typography variant="h2" color="black" className="mb-4 animate-fade duration-500 text-center"  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          Our Team
        </Typography>
        <Typography
            variant="h6"
            className="mb-4 px-3 text-left text-lg !text-black-500 font-normal lg:px-0 animate-fade duration-500 text-center" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}        >
          Meet our highly experienced and dedicated team who are always there for your career guidance and support.
        </Typography>
  
        <div className="col-span-2 grid grid-cols-1 sm:grid-cols-4 gap-x-10 mt-20 animate-fade duration-500 justify-center">
          {Users.map(({ image, username, description }) => (
            <div key={username} className="flex flex-col items-center pl-10 pr-10">
              <div className="relative rounded-full overflow-hidden border-4 border-teal-500 w-48 h-48 transform hover:scale-105 ">
                <Image
                  width={192}
                  height={192}
                  src={image}
                  alt={`${username} testimonial image`}
                  className="object-cover w-full h-full"
                />
              </div>
              <Typography
                variant="h5"
                className="mt-4 mb-2 text-center text-lg !text-black-500 font-bold animate-fade duration-500" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}              >
                {username}
              </Typography>
              <Typography
                variant="h6"
                className="text-center text-lg mb-8 !text-black-200 font-normal animate-fade duration-500"  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}              >
                {description}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
  )
}

export default OurTeams;
